<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        {{ $t('Filters') }}
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Tìm kiếm</label>
          <b-input-group>
            <b-form-input
              v-model="localSearchQuery"
              class="d-inline-block"
              placeholder="Từ khóa"
              @keyup.enter="updateSearchQuery"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="doSearch"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>

        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
// import vSelect from 'vue-select'
import useRoles from './useRoles';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  props: {
    roleFilter: {
      type: [Number, null],
      default: null,
    },
    statusFilter: {
      type: [Number, null],
      default: null,
    },
    searchQuery: {
      type: [String, null],
      default: null,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const localSearchQuery = ref('')
    const { statusOptions, genderOptions } = useRoles();

    const updateSearchQuery = () => {
      emit('update:searchQuery', localSearchQuery.value)
    }
    const doSearch = () => {
      emit('update:searchQuery', localSearchQuery.value)
    }
    return {
      localSearchQuery,
      statusOptions,
      genderOptions,
      updateSearchQuery,
      doSearch,
    };
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
